import { Navigate, Route, Routes } from 'react-router';
import Dashboard from 'routes/Home/Dashboard';
import NotFound from 'routes/NotFound';
import BrokerRecords from 'routes/Reference/BrokerRecords';
import CreateBroker from 'routes/Reference/CreateBroker';
import { ENavigationPath } from 'constants/path';
import CreateSubmission from 'routes/Submissions/CreateSubmission';
import CreateInsured from 'routes/Reference/CreateInsured';
import Login from 'routes/Login';
import { AuthProvider } from 'hooks/useAuth';
import { PrivateRoute } from 'routes/PrivateRoutes';
import UpdateBroker from 'routes/Reference/UpdateBroker';
import SubmissionDetail from 'routes/Submissions/SubmissionDetail';
import AuthCallback from 'routes/AuthCallback';
import BinderRecords from 'routes/Reference/BinderRecords';
import CreateBinder from 'routes/Reference/CreateBinder';
import InsuredRecords from 'routes/Reference/InsuredRecords';
import UpdateInsured from 'routes/Reference/UpdateInsured';
import UpdateBinder from 'routes/Reference/UpdateBinder';
import CreateReinsured from 'routes/Reference/CreateReinsured';
import UpdateReinsured from 'routes/Reference/UpdateReinsured';
import ReinsuredRecords from 'routes/Reference/ReinsuredRecords';
import ContractDetail from 'routes/Contracts/ContractDetail';
import ListReceipts from 'routes/PremiumReceipting/ListReceipts';
import CreateReceipt from 'routes/PremiumReceipting/CreateReceipt';
import UpdateReceipt from 'routes/PremiumReceipting/UpdateReceipt';
import ContractAdjustment from 'routes/Contracts/ContractAdjustment';
import OldDashboard from 'routes/Home/OldDashboard';
import CatEventRecords from 'routes/Reference/CatEventRecords';
import CreateCatEvent from 'routes/Reference/CreateCatEvent';
import UpdateCatEvent from 'routes/Reference/UpdateCatEvent';
import CurrencyRecords from 'routes/Reference/CurrencyRecords';
import RegisterNewMasterClaim from 'routes/Claims/RegisterMasterClaim';
import PaymentReserveChanges from 'routes/Claims/PaymentReserveChanges';
import ViewBinderContract from 'routes/PolicyManagement/ViewBinderContract';
import ClaimDetail from 'routes/Claims/ClaimDetail';
import ClaimsPaymentsDashboard from 'routes/Claims/ClaimsPaymentsDashboard';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path={ENavigationPath.LOGIN} element={<Login />} />
        <Route path={ENavigationPath.AUTH_CALLBACK} Component={AuthCallback} />
        <Route element={<PrivateRoute />}>
          <Route
            path={ENavigationPath.ROOT}
            element={<Navigate to={ENavigationPath.DASHBOARD} replace />}
          />
          <Route path={ENavigationPath.DASHBOARD} element={<Dashboard />} />
          <Route
            path={ENavigationPath.OLD_DASHBOARD}
            element={<OldDashboard />}
          />
          <Route
            path={ENavigationPath.NEW_SUBMISSION}
            element={<CreateSubmission />}
          />
          <Route
            path={ENavigationPath.UPDATE_BROKER}
            element={<UpdateBroker />}
          />
          <Route
            path={ENavigationPath.BROKER_RECORDS}
            element={<BrokerRecords />}
          />
          <Route path={ENavigationPath.NEW_BROKER} element={<CreateBroker />} />

          <Route
            path={ENavigationPath.CAT_EVENT_RECORDS}
            element={<CatEventRecords />}
          />
          <Route
            path={ENavigationPath.CURRENCY}
            element={<CurrencyRecords />}
          />
          <Route
            path={ENavigationPath.NEW_CAT_EVENT}
            element={<CreateCatEvent />}
          />
          <Route
            path={ENavigationPath.UPDATE_CAT_EVENT}
            element={<UpdateCatEvent />}
          />

          <Route
            path={ENavigationPath.BINDER_RECORDS}
            element={<BinderRecords />}
          />
          <Route
            path={ENavigationPath.UPDATE_BINDER}
            element={<UpdateBinder />}
          />
          <Route path={ENavigationPath.NEW_BINDER} element={<CreateBinder />} />
          <Route
            path={ENavigationPath.NEW_INSURED}
            element={<CreateInsured />}
          />
          <Route
            path={ENavigationPath.UPDATE_INSURED}
            element={<UpdateInsured />}
          />
          <Route
            path={ENavigationPath.NEW_REINSURED}
            element={<CreateReinsured />}
          />
          <Route
            path={ENavigationPath.UPDATE_REINSURED}
            element={<UpdateReinsured />}
          />
          <Route
            path={ENavigationPath.REINSURED_RECORDS}
            element={<ReinsuredRecords />}
          />
          <Route path={ENavigationPath.DEFAULT} element={<NotFound />} />
          <Route
            path={ENavigationPath.SUBMISSION_DETAIL}
            element={<SubmissionDetail />}
          />
          <Route
            path={ENavigationPath.CONTRACT_DETAIL}
            element={<ContractDetail />}
          />
          <Route
            path={ENavigationPath.CONTRACT_NEW_ADJUSTMENT}
            element={<ContractAdjustment />}
          />
          <Route
            path={ENavigationPath.CONTRACT_ADJUSTMENT_DETAIL}
            element={<ContractAdjustment />}
          />
          <Route
            path={ENavigationPath.INSURED_RECORDS}
            element={<InsuredRecords />}
          />
          <Route
            path={ENavigationPath.LIST_RECEIPTS}
            element={<ListReceipts />}
          />
          <Route
            path={ENavigationPath.NEW_RECEIPT}
            element={<CreateReceipt />}
          />
          <Route
            path={ENavigationPath.UPDATE_RECEIPT}
            element={<UpdateReceipt />}
          />
          <Route
            path={ENavigationPath.REGISTER_NEW_MASTER_CLAIM}
            element={<RegisterNewMasterClaim />}
          />
          <Route
            path={ENavigationPath.CLAIMS_PAYMENTS_DASHBOARD}
            element={<ClaimsPaymentsDashboard />}
          />
          <Route
            path={ENavigationPath.PAYMENT_RESERVE_CHANGE}
            element={<PaymentReserveChanges />}
          />
          <Route
            path={ENavigationPath.VIEW_BINDER_CONTRACT}
            element={<ViewBinderContract />}
          />
          <Route
            path={ENavigationPath.CLAIM_DETAIL}
            element={<ClaimDetail />}
          />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
